var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('admin-documents')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }